import React, { useEffect, useState } from "react";
import { CarouselSlider } from "./style";
import EventListener from "react-event-listener";
import { withRouter } from "react-router-dom";
import { BoxLoading } from "../loading";
import ErrorHandle from "../error/mainError";

const Modal = props => {
  const { current, show, files, groupId, loading, error, getRequest } = props;
  const [currentImage, changeCurrentImage] = useState(current);
  const [imageLoad, changeImageLoad] = useState(false);

  const setName = name => {
    let extraPart = "";
    if (groupId) {
      extraPart = `-${groupId}`;
    }
    return `${name}${extraPart}`;
  };
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
      changeImageLoad(true);
      changeCurrentImage(current);
    }
    return () => {
      document.body.style.overflow = "auto";
      changeImageLoad(false);
    };
  }, [show]);

  const src = file => {
    if (file && file.id) {
      return file.path;
    } else {
      if (file) {
        return window.URL.createObjectURL(file);
      }
    }
  };

  const changeSlide = pos => {
    let status = currentImage;
    if (pos === "next") {
      if (files.length > status + 1) {
        changeCurrentImage(status + 1);
      } else {
        changeCurrentImage(0);
      }
    }
    if (pos === "prev") {
      if (status === 0) {
        changeCurrentImage(files.length - 1);
      } else {
        changeCurrentImage(status - 1);
      }
    }
  };
  const toggleRefreshButton = (index, show) => {
    const id = `${setName("#m-refreshButtonId")}-${index}`;
    const refreshButton = document.querySelector(`${id}`);
    if (show) {
      refreshButton.style.display = "flex";
    } else {
      refreshButton.style.display = "none";
    }
  };
  const reloadImage = (e, index, imageSrc) => {
    const id = `${setName("#m-imageId")}-${index}`;
    const id_i = `${setName("#mi-imageId")}-${index}`;
    e.stopPropagation();
    const img = document.querySelector(`${id}`);
    const img_i = document.querySelector(`${id_i}`);
    img.src = imageSrc;
    img_i.src = imageSrc;
    toggleRefreshButton(index, false);
  };
  const downloadFile = file => {
    let filePath = file.path;
    let fileName = file.file_name;
    fetch(filePath)
      .then(res => res.blob())
      .then(res => {
        const aElement = document.createElement("a");
        aElement.setAttribute("download", fileName);
        aElement.href = URL.createObjectURL(res);
        aElement.setAttribute("target", "_blank");
        aElement.click();
        URL.revokeObjectURL(filePath);
      })
      .catch(e => console.log(e));
  };
  return (
    <CarouselSlider
      onClick={e => {
        e.stopPropagation();
        props.close();
      }}
      show={show}
    >
      <EventListener
        target="document"
        onKeyDown={e => {
          e.stopPropagation();
          if (e.keyCode === 37) {
            changeSlide("next");
          } else if (e.keyCode === 39) {
            changeSlide("prev");
          }
        }}
      />
      <div className="header">
        <i className="icon mapsa-close" />
        {files[currentImage] && files[currentImage].id && (
          <i
            className="icon mapsa-download"
            onClick={e => {
              e.stopPropagation();
              downloadFile(files[currentImage]);
            }}
          />
        )}
      </div>
      <div className="path">
        <div
          className="prev"
          onClick={e => {
            e.stopPropagation();
            changeSlide("prev");
          }}
        >
          <i className="icon mapsa-forward" />
        </div>
        {!error && !loading && imageLoad && (
          <div className="image-slider-file">
            <img
              src={files && src(files[currentImage])}
              id={`${setName("m-imageId")}-${currentImage}`}
              alt="تنخواه‌گردان"
              onError={() => {
                toggleRefreshButton(currentImage, true);
              }}
              onLoad={() => toggleRefreshButton(currentImage, false)}
            />
            <div
              className="refresh-button-container"
              id={`${setName("m-refreshButtonId")}-${currentImage}`}
              onClick={e =>
                reloadImage(e, currentImage, files[currentImage].path)
              }
            >
              <img src="/images/refresh.png" alt="" />
              بارگیری مجدد
            </div>
          </div>
        )}
        {loading && <BoxLoading size="small" />}
        <ErrorHandle message={error} request={() => getRequest()} />
        <div
          className="next"
          onClick={e => {
            e.stopPropagation();
            changeSlide("next");
          }}
        >
          <i className="icon mapsa-left-arrow-chevron" />
        </div>
      </div>
      <div className="footer">
        {!error &&
          !loading &&
          files &&
          files.map((file, i) => {
            return (
              <div
                className={`image-slider-file`}
                key={i}
                onClick={e => {
                  changeCurrentImage(i);
                  e.stopPropagation();
                }}
              >
                <img
                  className={`image-slider-img${
                    parseInt(i) === parseInt(currentImage) ? " selected" : ""
                  }`}
                  src={src(file)}
                  alt=""
                  id={`${setName("mi-imageId")}-${i}`}
                />
              </div>
            );
          })}
      </div>
    </CarouselSlider>
  );
};

export default withRouter(Modal);
